import { toValue, type MaybeRefOrGetter } from "vue";

import { NameFormatSetting, useSettingsStore } from "@/stores/settingsStore";
import { formatEntityName, type NameFields } from "@/utils/Formatters.ts";

export function useEntityNameFormatter() {
  const settingsStore = useSettingsStore();

  function formatName(
    entity: MaybeRefOrGetter<NameFields>,
    setting?: MaybeRefOrGetter<NameFormatSetting | undefined>
  ): string {
    const resolvedEntity = toValue(entity);

    if (!resolvedEntity) {
      return "";
    }

    const resolvedSetting =
      toValue(setting) ?? settingsStore.nameFormatSetting ?? NameFormatSetting.FIRST_LAST;

    return formatEntityName(resolvedEntity, resolvedSetting);
  }

  return {
    formatName,
  };
}
